export enum Verbosity {
    Detailed,
    Summary,
}